import {httpClient, utilService} from "../../service";
import {Button} from "react-bootstrap";
import React, {useEffect, useState} from "react";
import {HttpMethod} from "../../model";
import ReactDOM from "react-dom";
import QRCode from 'qrcode.react';
import {TtaSecModel} from '../verifications/VerifyConfigModel';

const T2Detail = (props: any) => {
    const item: TtaSecModel = props.item;
    const custNo = props.custNo;

    const [entity, setEntity] = useState<TtaSecModel>(item);
    const [loading, setLoading] = useState<boolean>(false);
    const [issueMsg, setIssueMsg] = useState<string>('N/A');
    const qrTd = `qrDd${item.idx}`;
    const qrDiv = `qrDiv${item.idx}`;
    const getIssueMsg = (data: TtaSecModel) => {
        if (data.id && data.id !== null) {
            return data.result ? '발급' : `거부<div class='tta-error-msg'>${data.resultMsg}</div>`;
        } else {
            return 'N/A';
        }
    }
    const doProcess = async (e: any) => {
        e.preventDefault();
        console.log(`click button id=${e.target}`);

        const qrId = document.getElementById(qrTd);
        setLoading(true);
        const url = `test/tta2`;
        const options = {
            method: HttpMethod.POST,
            url,
            body: item
        }
        const act = await httpClient(options);
        setLoading(false);
        if (act.result) {
            const data: TtaSecModel = act.data;
            setEntity({
                ...entity,
                id: data.id,
                startTime: data.startTime,
                endTime: data.endTime,
                difSec: data.difSec,
                result: data.result,
                resultMsg: data.resultMsg
            });
            setIssueMsg(getIssueMsg(data));
        } else {
            alert(act.errorMsg);
        }
    }

    let resultMsg = '';
    useEffect(() => {
        resultMsg = '검증전';
        if (item.id) {
            console.log(`id:${item.id},difSec=${item.difSec}`);
            setIssueMsg(getIssueMsg(item));
        }

    }, [item.idx]);

    if (entity.id) {
        if (entity.id > 0) {
            resultMsg = '성공';
        } else {
            resultMsg = '검증전';
        }
    } else {
        resultMsg = '검증전';
    }
    return (

        <>
            <tr>
                <td>{item.idx}</td>
                <td>{item.shopNm}</td>
                <td className={'align-left'}>{item.couponNm}({item.couponId})</td>
                <td>{entity.cpSrtDate?.substring(2)}~{entity.cpEndDate?.substring(5)}</td>
                <td>{entity.id ? (<div>완료</div>): (
                    <Button className="btn-primary" size="sm" onClick={doProcess} disabled={loading}
                            style={{width: '80px'}}>발급요청 {entity.id}</Button>)
                }
                </td>
                <td>
                    <div dangerouslySetInnerHTML={{__html: issueMsg}}></div>
                </td>
                <td>
                    {entity.startTime}
                </td>
                <td>
                    {entity.endTime}
                </td>
                <td>
                    {entity.difSec}
                </td>
                <td>
                    {resultMsg}
                </td>
            </tr>

        </>
    )
}
export default T2Detail;
